import type { ProjectType } from '@atlassian/jira-common-constants/src/project-types.tsx';
import type { SubProduct } from '@atlassian/jira-common-constants/src/sub-product-types.tsx';
import { subProductFromProjectType } from '@atlassian/jira-subproduct/src/index.tsx';

export const getSubProductFromProjectType = (projectType: ProjectType): SubProduct => {
	// for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
	if (projectType === 'product_discovery') {
		return 'polaris';
	}

	return subProductFromProjectType(projectType);
};
